module.exports = __webpack_public_path__ + "img/travel_pic_2.df402693.jpg";